/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { EntityType, IGenericDetailedReportRequestObject } from 'interfaces';
import { httpLegend } from 'services/http.legend';
import { InteractionInputDTO, ICustomizedLegendData } from '../CustomizedReportInterfaces';
import { ILegendDataHelper } from '../CustomizedReportHelper';

export class SPCTrendLegendHelper implements ILegendDataHelper {
  private legendData : any = undefined;

  preferences = {
    summary: {
      calculateCustomSummary: (options:any) => {
        if (this.legendData.legendSummary.length > 0 && this.legendData.legendSummary[0][0][options.name] !== undefined) {
          options.totalValue = this.legendData.legendSummary[0][0][options.name];
        }
      },
      totalItems: [
        // for aggregate function
        {
          name: 'AVG',
          summaryType: 'custom',
          displayFormat: 'Combined AVG: {0}',
          showInColumn: 'AVG',
          showInGroupFooter: true,
        },
        {
          name: 'MEDIAN',
          summaryType: 'custom',
          displayFormat: 'Combined MEDIAN: {0}',
          showInColumn: 'MEDIAN',
          showInGroupFooter: true,
        },
        {
          name: 'STDDEV',
          summaryType: 'custom',
          displayFormat: 'Combined STDDEV: {0}',
          showInColumn: 'STDDEV',
          showInGroupFooter: true,
        },
        {
          name: 'CP',
          summaryType: 'custom',
          displayFormat: 'Combined CP: {0}',
          showInColumn: 'CP',
          showInGroupFooter: true,
        },
        {
          name: 'CPK',
          summaryType: 'custom',
          displayFormat: 'Combined CPK: {0}',
          showInColumn: 'CPK',
          showInGroupFooter: true,
        },

        // without aggregate function
        {
          name: 'Combined Total Dies',
          summaryType: 'custom',
          displayFormat: 'Combined Total Dies: {0}',
          showInColumn: 'Total Dies',
          showInGroupFooter: true,
        },
        {
          name: 'Average Total Dies',
          summaryType: 'custom',
          displayFormat: 'Average Total Dies: {0}',
          showInColumn: 'Total Dies',
          showInGroupFooter: true,
        },
      ],
    },
    legendKeyExpression: 'wafer_key',
    selectionEventDefaults: {
      xAxisLabel: 'DIE_ID',
      yAxisLabel: 'DIE_ID',
      avoidXWhenGroupingPresent: true,
    },
    defaultGrouping: {
      groupKey: 'wafer_key',
      entityType: ('WAFER' as EntityType),
      columnName: 'key',
    },
    postSelectionInYAxis: false,
    equalNumberOfYsForX: false,
  };

  setLegendData = (data: ICustomizedLegendData) => {
    this.legendData = data;
  };

  getPreferences = () => (this.preferences);

  postCombinedEvent = (selectionEventInput: InteractionInputDTO) => {
    return httpLegend.setInteractionData(selectionEventInput);
  };

  getDetailedGraphLegendData = async (requestObject: IGenericDetailedReportRequestObject, callback: (legendData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };

  subscribeSelectionEvent = async (requestObject: IGenericDetailedReportRequestObject, callback: (graphData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };

  subscribeHidingEvent = async (requestObject: IGenericDetailedReportRequestObject, callback: (graphData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };
}
